<template>
  <v-card class="mx-2" width="224" @click="goToProductDetail(product.slug)">
    <v-img height="180" :src="product.image"></v-img>
    <div class="text--primary text-center font-weight-light text-lowercase first-capital-letter mt-2 mx-4">{{ product.name }}</div>
    <v-card-actions>
      <span class="ml-2 font-weight-medium">{{ product.price }}</span>
      <v-spacer></v-spacer>
      <v-btn class="text-rigth" color="blue" icon>
        <v-icon>add_shopping_cart</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import navigationMixin from '@/mixins/navigation'

export default {
  name: 'ProductCard',
  mixins: [navigationMixin],
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('shared', ['currency'])
  },
  methods: {
    goToProductDetail (slug) {
      this.goToRouteByName('Product-detail', { slug })
    }
  }
}
</script>
